import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

type Props = Pick<ImEventDto, 'url' | 'siteName'>;

export const Reference: React.FC<Props> = ({ url, siteName }) => {
  const theme = useTheme();
  return (
    <Table size="small">
      <TableBody
        sx={{
          '& td': {
            border: 0,
            verticalAlign: 'top',
            fontSize: {
              xs: theme.typography.body2.fontSize,
              sm: theme.typography.body1.fontSize
            }
          },
          '& td:nth-child(1)': {
            pl: 1,
            whiteSpace: 'nowrap'
          },
          '& td:nth-child(2)': {
            px: 0,
            wordWrap: 'break-word',
            wordBreak: 'break-all'
          }
        }}
      >
        {siteName && (
          <TableRow>
            <TableCell>参照サイト</TableCell>
            <TableCell>{siteName}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>参照URL</TableCell>
          <TableCell>
            <a
              href={url || undefined}
              target="_blank"
              rel="noopener noreferrer"
            >
              {url}
            </a>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
